import Vue from 'vue';
import currency from 'currency.js';

Object.defineProperty(Vue.prototype, '$currency', { value: currency });
